import { TravelService } from '../../services';

/* eslint-disable import/prefer-default-export */
export class PuntosTravelHelper {
  static handleChangeEnd = (date: string) => {
    const { options } = document.getElementById(
      'start_select',
    ) as HTMLSelectElement;
    const selectedDate = Number(date);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < options.length; i++) {
      const opt = Number(options[i].value);
      if (opt > selectedDate) {
        options[i].style.display = 'none';
      } else {
        options[i].style.display = 'block';
      }
    }
  };

  static handleChangeStart = (date: string) => {
    const { options } = document.getElementById(
      'end_select',
    ) as HTMLSelectElement;
    const selectedDate = Number(date);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < options.length; i++) {
      const opt = Number(options[i].value);
      if (opt < selectedDate) {
        options[i].style.display = 'none';
      } else {
        options[i].style.display = 'block';
      }
    }
  };

  static getCorrectTravelFunction = (param: any) => {
    return param === null
      ? TravelService.retrieveTravels()
      : TravelService.retrieveTravelsWithDate(param);
  };

  static getPuntosFormatted = (puntos: any) => {
    if (puntos > 999 && puntos < 10000) {
      const b = puntos / 1000;
      const c = b.toLocaleString().charAt(0).concat('.');
      return puntos
        .toLocaleString()
        .replace(puntos.toLocaleString().charAt(0), c);
    }
    return puntos ? puntos.toLocaleString() : puntos;
  };
}
